import { useEffect, useRef, useState } from "react";
import moment from "moment-timezone";
import useGlobalStore from "../../store/global.store";
import { useConfig } from "../../hooks/useConfig";
import { useRemote } from "../../hooks/useRemote";
import { constants } from "../../config/constants";

const Utility = () => {
  const hasVipAddOn = useGlobalStore((state) => state.hasVipAddOn);
  const { config } = useConfig();
  const { updateView } = useRemote();
  const [livePianoAnnouncementValue, setLivePianoAnnouncementValue] =
    useState(null);
  const announcementAudioRef = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = moment().tz("America/New_York"); // EST timezone

      console.log(
        "Auto Restart: ",
        currentTime.format("HH:mm"),
        config.autoRestartTime
      );
      if (currentTime.format("HH:mm") === config.autoRestartTime) {
        if (config.promotion && !useGlobalStore.getState().hasBeaconAddOn) {
          updateView("BAND__upgrade", () => {
            window.location.reload();
            localStorage.setItem("memClear", "yes");
          });
        } else {
          window.location.reload();
          localStorage.setItem("memClear", "yes");
        }
      }
    }, 50000); // 50000ms = 50 seconds
    return () => clearInterval(interval);
  }, [config.autoRestartTime, config.promotion]);

  useEffect(() => {
    console.log("Piano_Show_On: ", config.Piano_Show_On);
    console.log("hasVipAddOn: ", hasVipAddOn);
    if (config.Piano_Show_On && hasVipAddOn) {
      const autoStart = localStorage.getItem(constants.LIVE_PIANO_AUTOSTART);
      if (autoStart === "false") {
        return;
      }
      updateView("VIP__piano");
    }
  }, [config.Piano_Show_On]);

  useEffect(() => {
    if (config?.Live_Piano_Announcement) {
      setLivePianoAnnouncementValue(config?.Live_Piano_Announcement);

      if (
        livePianoAnnouncementValue !== null &&
        livePianoAnnouncementValue !== config?.Live_Piano_Announcement
      ) {
        console.log("livePianoRefreshValue", livePianoAnnouncementValue);
        console.log(
          "config?.Live_Piano_Announcement",
          config?.Live_Piano_Announcement
        );
        const playLivePianoAnnouncement = localStorage.getItem(
          constants.LIVE_PIANO_ANNOUNCEMENT
        );

        console.log("playLivePianoAnnouncement", playLivePianoAnnouncement);

        if (playLivePianoAnnouncement === "false") {
          return;
        }

        if (hasVipAddOn) {
          announcementAudioRef.current.volume = 0.5;
          announcementAudioRef.current.play();
        }
      }
    }
  }, [
    config?.Live_Piano_Announcement,
    livePianoAnnouncementValue,
    announcementAudioRef,
    hasVipAddOn,
  ]);

  return (
    <>
      <audio
        id="announcement-audio"
        src={config.Live_Piano_Announcement_File}
        autoPlay={false}
        loop={false}
        ref={announcementAudioRef}
      />
    </>
  );
};

export default Utility;
